import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageService } from 'src/app/models/PageService';
import { PageServiceService } from '../service/page-service.service';
import {MenuUtil, SERVICE_URL} from "../../utils/menu-utils";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-messervices',
  templateUrl: './messervices.component.html',
  styleUrls: ['./messervices.component.scss'],
})
export class MesservicesComponent implements OnInit, OnDestroy {

  /**Spinner Status */
  progressSpinner: boolean = false;
  spinner: boolean = true;
  public item: PageService = null;
  private hiddenId : number;
  private subscription : Subscription;

  constructor(private readonly route: ActivatedRoute, private router: Router,
    private readonly api: PageServiceService) {
  }

  getPageService(id: number) {
    this.spinner = true;
    this.progressSpinner = true;
    this.api.getPageServiceById(id).subscribe({
      next: item => {
        this.item = item;
        this.spinner = false;
      },
      error: error => {
        console.log(error);
        this.spinner = false;
      }
    });
  }

  ngOnInit() {
    this.subscription = MenuUtil._menuIdSubject$.asObservable().subscribe({
      next: (value) => {
        this.hiddenId = value.id;
        if(value.url === SERVICE_URL || value.routerLink === SERVICE_URL)
          this.getPageService(this.hiddenId);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
